module.exports = __webpack_public_path__ + "static/media/cv_foto.0acedc7c.png";